import { languages } from 'monaco-editor/esm/vs/editor/editor.api';
import { merge } from 'lodash';
import * as groovy from '@/commons/components/monaco-editor/basic-languages/groovy/groovy';
import snippets from "./snippets";
import iqpLang from '@/commons/components/monaco-editor/language/lang';
import lsp from '@/commons/components/monaco-editor/language/lsp';

export const conf = merge({}, groovy.conf);
export const language = merge({}, groovy.language);

function asDisposable(disposables) {
    return { dispose: function () { return disposeAll(disposables); } };
}
function disposeAll(disposables) {
    while (disposables.length) {
        disposables.pop().dispose();
    }
}

export function setupMode(ops) {
    const languageId = ops.languageId;
    const params = ops || {};
    const disposables = [];
    const providers = [];

    function registerProviders() {
        disposeAll(providers);
        providers.push(languages.setMonarchTokensProvider(languageId, language));
        providers.push(lsp(languageId, iqpLang(snippets)));
    }
    registerProviders();
    disposables.push(languages.setLanguageConfiguration(languageId, conf));
    disposables.push(asDisposable(providers));
    return asDisposable(disposables);
}
